import InputAdornment from "@material-ui/core/esm/InputAdornment";
import React from 'react';
import { useTranslation } from 'react-i18next';
export default function OptionalInputAdornment() {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(InputAdornment, {
    position: "end"
  }, t('profile.optional'));
}